import { useRef, useState } from "react";
import Grid from "@material-ui/core/Grid";
import * as XLSX from "xlsx";
import NewButton from "../../Utils/Botones/NewButton";
import DataTable from "../../Utils/DataTables";
import NewModal from "../../Utils/Visuales/NewModal";
import InputCheck from "../../Vistas/InputCheck";
import { CircularProgress } from "@material-ui/core";
import { enqueueSnackbar } from "notistack";
import { postRequest } from "../Funciones/requester";
import moment from "moment";
import { UploadFile } from "@mui/icons-material";
import {
  headersBloqueoEstatus,
  headersBloqueoProcesar,
  headersDesbloqueoProcesar,
} from "../data/bloqueAcademicoDocente";

const BloqueAcademicoDocenteSubirArchivo = ({
  modalBloqueoIsOpen,
  dataBloqueo,
  noFooterBloqueoGrupal,
  setDataBloqueo,
  setErrorOcurred,
  setModalBloqueoIsOpen,
  setNoFooterBloqueoGrupal,
}) => {
  const [count, setCount] = useState(1);
  const [checkEstatus, setCheckEstatus] = useState([]);
  const [fileAvailable, setFileAvailable] = useState(false);
  const [loadingBloqueo, setLoadingBloqueo] = useState(false);
  const [headersBloque, setHeadersBloque] = useState(false);
  const [checkBox, setCheckBox] = useState(true);
  const inputFile = useRef(null);

  const onButtonClick = () => inputFile.current.click();

  async function handleSubmitBloqueoGrupal() {
    if (checkEstatus.length === 0) {
      enqueueSnackbar("SELECCIONE ELEMENTOS A PROCESAR", {
        variant: "error",
        autoHideDuration: null,
      });
    } else {
      setNoFooterBloqueoGrupal(true);
      setHeadersBloque(true);
      setLoadingBloqueo(true);
      const dataCopy = [...checkEstatus].slice(1);
      setDataBloqueo(dataCopy);
      const data_ = [];
      const url = checkBox
        ? "/asignaciones/bloqueo-academico"
        : "/asignaciones/bloqueo-academico/nuevo";
      for (let i = 0; i < dataCopy.length; i++) {
        const body = {
          clave_profesor: `${dataCopy[i][0]}`,
          clave_campus: `${dataCopy[i][2]}`,
          clave_escuela: `${dataCopy[i][3]}`,
          comentario: dataCopy[i][4],
        };
        if (checkBox) {
          body.autorizado_por = dataCopy[i][5];
          body.fecha_autorizado = moment().format("YYYY-MM-DD");
          body.estatus = "inactivo";
        }
        try {
          setErrorOcurred(false);
          const response = await postRequest(url, body);
          setCount((prev) => prev + 1);
          if (response.s === "OK") {
            data_.push([
              dataCopy[i][0],
              dataCopy[i][1],
              dataCopy[i][2],
              dataCopy[i][3],
              response.s,
            ]);
            enqueueSnackbar(response.m, { variant: "success" });
          } else {
            data_.push([
              dataCopy[i][0],
              dataCopy[i][1],
              dataCopy[i][2],
              dataCopy[i][3],
              `Error: ${response.m}`,
            ]);
            enqueueSnackbar(`${response.m}`, {
              variant: "error",
              autoHideDuration: null,
            });
          }
        } catch (error) {
          setLoadingBloqueo(false);
          enqueueSnackbar(error, { variant: "error", autoHideDuration: null });
        }
        setTimeout(() => {}, 5000);
      }
      setLoadingBloqueo(false);
      setDataBloqueo([]);
      setDataBloqueo(data_);
    }
  }

  const handleCheckEstatus = (data, idRow, valor) => {
    const checked = valor.target.checked;
    const p = checkEstatus;
    if (checked === true) {
      p.push(data);
      setCheckEstatus(p);
    } else {
      setCheckEstatus((prev) =>
        prev.filter((x) => {
          return `${x[0]}-${x[3]}` !== `${data[0]}-${data[3]}`;
        })
      );
    }
  };

  const handleUpload = (e) => {
    var reader = new FileReader();
    reader.onload = function (e) {
      var data = e.target.result;
      let readedData = XLSX.read(data, { type: "binary" });
      const wsname = readedData.SheetNames[0];
      const ws = readedData.Sheets[wsname];
      const dataParse = XLSX.utils.sheet_to_json(ws, { header: 1 });
      try {
        const datos = [];
        const fechaActual = moment().format("DD-MM-YYYY");
        if (
          (dataParse[0].length === 5 &&
            dataParse[0][0] === "clave_profesor" &&
            dataParse[0][1] === "nombre_profesor" &&
            dataParse[0][2] === "campus" &&
            dataParse[0][3] === "escuela" &&
            dataParse[0][4] === "motivo" &&
            !checkBox) ||
          (dataParse[0].length === 6 &&
            dataParse[0][0] === "clave_profesor" &&
            dataParse[0][1] === "nombre_profesor" &&
            dataParse[0][2] === "campus" &&
            dataParse[0][3] === "escuela" &&
            dataParse[0][4] === "motivo" &&
            dataParse[0][5] === "Autorizado_por" &&
            checkBox)
        ) {
          for (let f = 1; f < dataParse.length; f++) {
            const fila = [];
            for (let i = 0; i < dataParse[f].length; i++) {
              if (dataParse[f][i] === undefined) {
                return enqueueSnackbar(
                  "Hay datos faltantes en el documento subido",
                  { variant: "error", autoHideDuration: null }
                );
              }
              fila.push(dataParse[f][i]);
            }
            fila.push(fechaActual, checkBox ? "Inactivo" : "Activo");
            fila.push(
              <InputCheck
                handleCheckEstatus={handleCheckEstatus}
                data={dataParse[f]}
                index={dataParse[f].length}
              />
            );
            datos.push(fila);
          }
          setDataBloqueo(datos);
          setFileAvailable(true);
          setCheckEstatus(dataParse);
        } else {
          enqueueSnackbar(
            checkBox
              ? "El archivo seleccionado no es formato .xlsx o no corresponde para desbloqueo"
              : "El archivo seleccionado no es formato .xlsx o no corresponde para bloqueo",
            { variant: "error", autoHideDuration: null }
          );
          return;
        }
      } catch (error) {}
    };
    if (e.target.files[0] !== undefined) {
      reader.readAsArrayBuffer(e.target.files[0]);
    }
  };

  function downloadFileBloqueo() {
    window.location.href =
      "https://s3.us-west-1.amazonaws.com/unitecsica.com/plantilla_bloqueo_academico_masivo.xlsx";
  }

  function downloadFileDesbloqueo() {
    window.location.href = "https://unitecsica.com/Plantilla_Desbloqueo.xlsx";
  }

  const handleChangeStatus = () => setCheckBox((prev) => !prev);

  return (
    <NewModal
      title="Bloqueo Académico Grupal"
      open={modalBloqueoIsOpen}
      handleClose={() => {
        setDataBloqueo([]);
        setCheckEstatus([]);
        setFileAvailable(false);
        setModalBloqueoIsOpen(false);
        setCount(1);
        setHeadersBloque(false);
      }}
      handleSubmit={handleSubmitBloqueoGrupal}
      noFooter={noFooterBloqueoGrupal}
      maxWidth={dataBloqueo.length ? 1500 : 700}
    >
      <div style={{ padding: "25px" }}>
        {fileAvailable ? (
          <>
            <h3>Seleccionar elementos a procesar</h3>
            {loadingBloqueo ? (
              <div style={{ textAlign: "center", marginTop: "10px" }}>
                <CircularProgress size={50} />
                <p>
                  {count}/{checkEstatus.length - 1}
                </p>
              </div>
            ) : (
              <DataTable
                headers={
                  headersBloque
                    ? headersBloqueoEstatus
                    : checkBox
                    ? headersDesbloqueoProcesar
                    : headersBloqueoProcesar
                }
                data={dataBloqueo}
                centrar={[1, 2, 3, 4, 5]}
                bordes
              />
            )}
          </>
        ) : (
          <Grid>
            <Grid
              style={{
                display: "flex",
                marginTop: "20px",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <input
                id="lock"
                type="checkbox"
                value="Inactivo"
                checked={checkBox}
                onChange={handleChangeStatus}
              />
              <label htmlFor="lock" style={{ marginLeft: "15px" }}>
                Desbloqueo
              </label>
              <input
                id="unlock"
                type="checkbox"
                value="Activo"
                style={{ marginLeft: "40px" }}
                checked={!checkBox}
                onChange={handleChangeStatus}
              />
              <label style={{ marginLeft: "15px" }} htmlFor="unlock">
                Bloqueo
              </label>
            </Grid>
            <Grid
              container
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "space-around",
                marginTop: "20px",
              }}
            >
              <input
                style={{ display: "none" }}
                ref={inputFile}
                onChange={handleUpload}
                type="file"
              />
              <NewButton
                onClick={onButtonClick}
                noIcon
                style={{
                  backgroundColor: "#026eb7",
                  color: "white",
                  padding: "5px 15px",
                  borderRadius: "5px",
                  display: "flex",
                  alignItems: "center",
                }}
                customText="Subir Archivo"
                rightIcon={<UploadFile style={{ marginLeft: 10 }} />}
              />
            </Grid>
            <Grid
              container
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "space-around",
                marginTop: "20px",
              }}
            >
              <NewButton
                onClick={downloadFileBloqueo}
                noIcon
                style={{ padding: "5px 15px", borderRadius: "5px" }}
                customText="Descargar Plantilla Bloqueo"
              />
              <NewButton
                onClick={downloadFileDesbloqueo}
                noIcon
                style={{ padding: "5px 15px", borderRadius: "5px" }}
                customText="Descargar Plantilla Desbloqueo"
              />
            </Grid>
          </Grid>
        )}
      </div>
    </NewModal>
  );
};

export default BloqueAcademicoDocenteSubirArchivo;
